import { render, staticRenderFns } from "./ChildTreeTable.vue?vue&type=template&id=127d4b37"
import script from "./ChildTreeTable.vue?vue&type=script&lang=ts"
export * from "./ChildTreeTable.vue?vue&type=script&lang=ts"
import style0 from "./ChildTreeTable.vue?vue&type=style&index=0&id=127d4b37&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports